import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const SUSDE_URL =
  'https://yields.llama.fi/poolsEnriched?pool=66985a81-9c51-46ca-9977-42b4fe7bc6df'

export const susdeFetcher: YieldFetcher = {
  label: 'SUSDE',
  fetch: async () => {
    try {
      const res = await fetch(SUSDE_URL).then((r) => r.json())
      return { SUSDE: apyToAprPercent(res?.data[0]?.apy ?? 0) }
    } catch (e) {
      return { SUSDE: 0 }
    }
  },
}
